<template>
  <app-content class="reports">
    <b-container fluid>
      <b-row>
        <b-tabs v-model="activeTab" class="w-100">
          <b-tab
            v-for="(tab, index) in allowedTabs"
            :key="tab.name"
            :title="tab.title"
          >
            <component
              v-if="shouldRenderComponent(index)"
              class="w-100"
              :is="tab.component"
            />
          </b-tab>
        </b-tabs>
      </b-row>
    </b-container>
  </app-content>
</template>

<script>
import router from '@/router';

const DataHistory = () => import(/* webpackChunkName: "dataHistoryReport" */ './dataHistory');
const Oscillography = () => import(/* webpackChunkName: "oscillographyReport" */ './oscillography');
const AlarmsAndWarnings = () => import(/* webpackChunkName: "alarmsAndWarningsReport" */ './alarmsAndWarnings');
const AssetRelation = () => import(/* webpackChunkName: "assetsRelationReport" */ './assetsRelation');
const DiagnosticsHistory = () => import(/* webpackChunkName: "diagnosticsHistoryReport" */ './diagnosticsHistory');
const OperationsHistory = () => import(/* webpackChunkName: "operationsHistory" */ './operationsHistory');
const NetworkStatusHistory = () => import(/* webpackChunkName: "networkStatusReport" */ './networkStatusHistory');

export default {
  name: 'Reports',
  components: {
    DataHistory,
    Oscillography,
    OperationsHistory,
    AlarmsAndWarnings,
    AssetRelation,
    DiagnosticsHistory,
    NetworkStatusHistory,
  },
  props: {
    activeTabName: {
      type: String || null,
    },
  },
  data: () => ({
    activeTab: 0,
  }),
  computed: {
    tabs() {
      return [
        {
          name: 'data-history',
          component: DataHistory,
          canAccess: this.$hasUserPermission('PER023'),
          title: this.$t('reports.data-history.title'),
        },
        {
          name: 'oscillography',
          component: Oscillography,
          canAccess: this.$hasUserPermission('PER024'),
          title: this.$t('reports.oscillography.oscillography'),
        },
        {
          name: 'alarms-and-warnings',
          component: AlarmsAndWarnings,
          canAccess: this.$hasUserPermission('PER025'),
          title: this.$t('reports.alarms-and-warnings.title'),
        },
        {
          name: 'operations-history',
          component: OperationsHistory,
          title: this.$t('reports.operations-history.title'),
          canAccess: this.$hasUserPermission('PER022'),
        },
        {
          name: 'asset-relation',
          component: AssetRelation,
          canAccess: this.$hasUserPermission('PER026'),
          title: this.$t('reports.asset-relation.title'),
        },
        {
          name: 'diagnostics-history',
          component: DiagnosticsHistory,
          canAccess: this.$hasUserPermission('PER027'),
          title: this.$t('reports.diagnostics-history.title'),
        },
        {
          name: 'network-status-history',
          component: NetworkStatusHistory,
          canAccess: this.$hasUserPermission('PER018'),
          title: this.$t('reports.network-status-history'),
        },
      ];
    },
    allowedTabs() {
      return this.tabs.filter(({ canAccess }) => canAccess);
    },
  },
  created() {
    this.verifyPermission();
    this.setActiveTab();
  },
  methods: {
    setActiveTab() {
      const activeTabName = this.activeTabName || this.$route.params.activeTabName;
      if (activeTabName) {
        this.activeTab = this.tabs.findIndex(tab => tab.name === activeTabName);
      }
    },
    shouldRenderComponent(index) {
      return this.activeTab === index;
    },
    verifyPermission() {
      const requiredPermission = [
        'PER018',
        'PER022',
        'PER023',
        'PER024',
        'PER025',
        'PER026',
        'PER027',
      ];

      if (!this.$hasUserAnyPermission(requiredPermission)) {
        router.push({ name: 'monitoring' });
      }
    },
  },
};

</script>
